export const SPECIFICATIONS_PAGE_STEPS = {
    STEP_SIDEBAR_HIDDEN: 0,
    STEP_SELECT_RESTAURANT: 1,
    STEP_SELECT_PRODUCT_CATEGORY: 2,
    STEP_SELECT_PRODUCT: 3,
}

const values = Object.values(SPECIFICATIONS_PAGE_STEPS);

export const MIN_SPECIFICATIONS_PAGE_STEP = Math.min(...values);
export const MAX_SPECIFICATIONS_PAGE_STEP = Math.max(...values);
